import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { CampanhaPipelineCardInfoNaoConfirmadaModule } from '../nao-confirmada';
import { CampanhaPipelineCardInfoEmAnaliseModule } from '../em-analise';
import { CampanhaPipelineCardInfoVigenciaModule } from '../vigencia';
import { CampanhaPipelineCardInfoReprovadaModule } from '../reprovada';

import { CampanhaPipelineCardInfoStatusComponent } from './campanha-pipeline-card-info-status.component';

@NgModule({
    imports: [
        SharedModule,
        CampanhaPipelineCardInfoNaoConfirmadaModule,
        CampanhaPipelineCardInfoEmAnaliseModule,
        CampanhaPipelineCardInfoVigenciaModule,
        CampanhaPipelineCardInfoReprovadaModule
    ],
    declarations: [
        CampanhaPipelineCardInfoStatusComponent
    ],
    exports: [
        CampanhaPipelineCardInfoStatusComponent
    ]
})
export class CampanhaPipelineCardInfoStatusModule { }
